import { resolveBrMediaUrl } from '../utils/brDocument';

/** 列表缩略图 / 预览弹窗共用（含 Figma 资料栏所需 item） */
export default {
  data() {
    return {
      showPreview: false,
      previewSrc: '',
      previewItem: null,
    };
  },
  methods: {
    resolveBrThumbUrl(item) {
      return resolveBrMediaUrl(item?.mediaFileName || item?.MediaFileName);
    },
    openBrImagePreview(item) {
      const url = this.resolveBrThumbUrl(item);
      if (!url) {
        return;
      }
      this.previewSrc = url;
      this.previewItem = item || null;
      this.showPreview = true;
    },
  },
};
